import { createAction } from '@reduxjs/toolkit';

export const setViewedProductGroup = createAction('products/setViewedProductGroup', (viewedProductGroup, productIRI, products) => ({
  payload: {
    viewedProductGroup,
    productIRI,
    products,
  },
}));

export const setProductGroupsList = createAction('products/setProductGroupsList', (productGroupsList) => ({
  payload: {
    productGroupsList,
  },
}));

export const setErrorMessage = createAction('products/setErrorMessage', (errorMessage) => ({
  payload: {
    errorMessage,
  },
}));

export const fetchSingleProductGroup = createAction('products/fetchSingleProductGroup', (productGroupNumber, productIRI, products) => ({
  payload: {
    productGroupNumber,
    productIRI,
    products,
  },
}));

export const fetchProductGroupsData = createAction('products/fetchProductGroupsData', (filterName, filterValue) => ({
  payload: {
    filterName,
    filterValue,
  },
}));

export const addAssociation = createAction('products/addAssociation', (multiplier, groupIRI, associationIRI) => ({
  payload: {
    multiplier,
    groupIRI,
    associationIRI,
  },
}));

export const deleteAssociation = createAction('products/deleteAssociation', (associationIRI) => ({
  payload: {
    associationIRI,
  },
}));
